import { useCallback, useEffect, useRef, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

import { EhrChatData } from 'chaika-frontend-types/frontend-cms';

import { patientService } from '@modules/patient/services/patient/patientService';

interface Params {
    patientId: string;
}

interface UsePatientChats {
    chats: EhrChatData[];
    doPatientHasChats: boolean;
    isLoaded: boolean;
    reload(): Promise<EhrChatData[]>;
}

export const usePatientChats = ({ patientId }: Params): UsePatientChats => {
    const loadedForPatient = useRef<string>(undefined);

    const [chats, setChats] = useState<EhrChatData[]>([]);
    const [isLoaded, setIsLoaded] = useState(false);

    const reload = useCallback(async () => {
        const chats = await patientService.loadTgChatLinks(patientId);

        setChats(chats);
        setIsLoaded(true);

        return chats;
    }, [patientId]);

    useEffect(() => {
        if (loadedForPatient.current !== patientId) {
            loadedForPatient.current = patientId;

            setIsLoaded(false);
            reload();
        }
    }, [patientId, reload]);

    return {
        reload,
        chats,
        doPatientHasChats: !isEmpty(chats),
        isLoaded,
    };
};
